import { create } from "zustand";
import type { DocID } from "@/types";

/**
 * "Não lidas" (SA-1455) da aba Em atendimento: vai como `unread=true` na
 * query da aba, que o servidor filtra pela não lida do Redis.
 *
 * `keptReadChatId` é a conversa aberta: lida, ela continua na lista enquanto
 * está aberta (não some debaixo do clique) e sai quando outra abre, quando
 * ela fecha ou quando o filtro é religado.
 */
type ChatUnreadFilterState = {
  unreadOnly: boolean;
  keptReadChatId: DocID | null;
  toggleUnreadOnly: () => void;
  clearUnreadOnly: () => void;
  setKeptReadChatId: (chatId: DocID | null) => void;
};

export const useChatUnreadFilter = create<ChatUnreadFilterState>((set) => ({
  unreadOnly: false,
  keptReadChatId: null,
  toggleUnreadOnly: () => set((state) => ({ unreadOnly: !state.unreadOnly })),
  clearUnreadOnly: () => set({ unreadOnly: false }),
  setKeptReadChatId: (chatId) => set({ keptReadChatId: chatId }),
}));
